import { GLASS_ELEMENT, WALL_LIGHTBAND, GATE, DOOR_CANOPY, DOOR } from '../../Constants/ObjectTypes';
import { isXSide, isZSide } from '../Selectors/Side';
import { getAxisValueBySide } from '../../Visualization/objectControls';
import { getSegmentsWidth, getWallSegmentIndexAtPosition } from '../Selectors/Helpers';

const MaxDoorCountBySegmentWidth = {
  2: 0,
  3: 1,
  4: 1,
  5: 2,
  6: 2,
};

const getMaxDoorCount = (segmentWidth) => MaxDoorCountBySegmentWidth[segmentWidth] || 0;

const getAddRuleWarehouse = (configuration, object) => {
  const ruleMap = {
    any: {
      getConfirmMessage: () => {},
      applyRule: () => {},
    },
    [GLASS_ELEMENT]: {
      getConfirmMessage() {
        if (!this.getConflictingObjects(configuration, object).length) {
          return;
        }
        return {
          content: 'glassElementConfirmDialog.content',
          confirmButtonLabel: 'glassElementConfirmDialog.confirmButtonLabel',
        };
      },
      applyRule() {
        const objectsToRemove = this.getConflictingObjects(configuration, object);
        for (const o of objectsToRemove) {
          const index = configuration.objects.indexOf(o);
          configuration.objects.splice(index, 1);
        }
      },
      getConflictingObjects(configuration, object) {
        return configuration.objects.filter((o) => o.side === object.side && o.index === object.index);
      },
    },
  };

  const disableRuleMap = {
    any: {
      isDisabled() {
        return (
          (object.type &&
            configuration?.objects?.some(
              (o) =>
                o !== object.objectRef &&
                o.side === object.side &&
                o.index === object.index &&
                o.type === GLASS_ELEMENT
            )) ||
          (object.type !== GLASS_ELEMENT &&
            configuration?.objects?.some(
              (o) =>
                o !== object.objectRef &&
                o.side === object.side &&
                o.index === object.index &&
                o.type === GATE
            )) ||
          false
        );
      },
    },
    [WALL_LIGHTBAND]: {
      isDisabled() {
        return (
          disableRuleMap.any.isDisabled() ||
          isZSide(object.side) || // disabled for width sides
          configuration?.objects?.some(
            (o) =>
              o.side === object.side && o.index === object.index && [WALL_LIGHTBAND, GATE].includes(o.type)
          ) ||
          false
        );
      },
    },
    [GATE]: {
      isDisabled() {
        return (
          disableRuleMap.any.isDisabled() ||
          configuration?.objects?.some(
            (o) => o !== object.objectRef && o.side === object.side && o.index === object.index
          ) ||
          (object.itemIdentifier === 'sliding_gate' &&
            (object.index === 0 ||
              object.index ===
                getAxisValueBySide(
                  { x: configuration.xWallSegmentCount - 1, z: configuration.zWallSegmentCount - 1 },
                  object.side
                ))) ||
          false
        );
      },
    },
    [DOOR_CANOPY]: {
      isDisabled() {
        return (
          disableRuleMap.any.isDisabled() ||
          // there is no door without canopy at the target position
          !configuration?.objects?.some(
            (o) =>
              o.side === object.side &&
              o.index === object.index &&
              DOOR === o.type &&
              !o.children?.some((o) => o.type === DOOR_CANOPY)
          ) ||
          false
        );
      },
    },
    [DOOR]: {
      isDisabled() {
        return (
          disableRuleMap.any.isDisabled() ||
          configuration?.objects?.some(
            (o) =>
              o !== object.objectRef &&
              o.side === object.side &&
              o.index === object.index &&
              [GATE, DOOR].includes(o.type)
          )
        );
      },
    },
  };

  return {
    ...disableRuleMap.any,
    ...disableRuleMap[object.type],
    ...ruleMap.any,
    ...ruleMap[object.type],
  };
};

const isPVCWall = (configuration, side, index) => {
  const wallType =
    configuration.indexedWallTypes.find((wall) => wall.side === side && wall.index === index) ||
    configuration.wallType;
  return (wallType?.option?.identifier || wallType?.identifier || wallType).startsWith('wall_pvc_');
};

const getAddRuleTent = (configuration, object) => {
  const ruleMap = {
    any: {
      getConfirmMessage: () => {},
      applyRule: () => {},
    },
  };

  const disableRuleMap = {
    any: {
      isDisabled() {
        return false;
      },
    },
    [DOOR]: {
      isDisabled() {
        const objectIndex = getWallSegmentIndexAtPosition(configuration, object);
        if (
          isXSide(object.side) &&
          configuration.ropeIndex.includes(objectIndex) &&
          isPVCWall(configuration, object.side, objectIndex)
        ) {
          return true;
        }
        const maxDoorCountAtIndex = getMaxDoorCount(getSegmentsWidth(configuration, object)?.[objectIndex]);
        return (
          configuration?.objects?.filter(
            (o) =>
              o !== object.objectRef &&
              o.side === object.side &&
              getWallSegmentIndexAtPosition(configuration, o) === objectIndex &&
              DOOR === o.type
          ).length >= maxDoorCountAtIndex
        );
      },
    },
  };

  return {
    ...disableRuleMap.any,
    ...disableRuleMap[object.type],
    ...ruleMap.any,
    ...ruleMap[object.type],
  };
};

const getAddRule = (configuration, object) => {
  switch (configuration.itemIdentifier) {
    case 'warehouse':
      return getAddRuleWarehouse(configuration, object);
    case 'tent':
      return getAddRuleTent(configuration, object);
  }
};

export default getAddRule;
